import React, { useMemo, useState } from 'react';

import { Box } from '@mui/material';
import RouteCard from 'views/delivery-board/components/route-card';
import { DeliveryBoardItem } from 'views/delivery-board/types/delivery-board-model.type';

import './assets/info-window.css'; // what does this do in this file? this looks like css applied to google maps
import FactoryMarker from './markers/factory-marker';
import SiteMarker from './markers/site-marker';
import VesselMarker from './markers/vessel-marker';
import { GoogleMapsMarkerInfo } from 'types/google-maps/google-maps-marker-info.type';
import { Factory } from '../types/factory.type';

type Props = {
  sites?: GoogleMapsMarkerInfo[];
  vessels?: DeliveryBoardItem[];
  factories?: Factory[];
};

//#TODO this component is used in several places and not specific to delivery board. Separate out the common functionality of this component for reuse
const MarkerContainer: React.FC<Props> = ({ vessels, sites, factories }) => {
  //#region STATES

  const [activeMarker, setActiveMarker] = useState<string>('');
  const [selectedVessel, setSelectedVessel] = useState<DeliveryBoardItem>();

  //#endregion STATES

  const siteMarkers = useMemo(
    () => sites?.map((marker, idx) => <SiteMarker key={`marker_${idx}`} marker={marker} activeMarker={activeMarker} />),
    [sites, activeMarker]
  );

  const factoryMarkers = useMemo(
    () =>
      factories?.filter((f) =>
        f.factoryLocation?.latitude != null &&
        f.factoryLocation?.longitude != null
      ).map((factory: Factory, idx: number) => {
        return <FactoryMarker factory={factory} activeMarker={activeMarker} key={idx} />;
      }),
    [factories, activeMarker]
  );

  const vesselMarkers = useMemo(
    () =>
      vessels?.filter((i) =>
        i.vesselLocation?.latitude != null &&
        i.vesselLocation?.longitude != null
      ).map((vessel, idx) => (
        <VesselMarker
          key={idx}
          data={vessel}
          activeMarker={activeMarker}
          onClick={(e) => {
            setSelectedVessel(vessel);
            if (activeMarker === vessel.distributionId) setActiveMarker('');
            else setActiveMarker(vessel.distributionId);
          }}
        />
      )),
    [vessels, activeMarker]
  );

  return (
    <>
      {siteMarkers}
      {vesselMarkers}
      {factoryMarkers}
      {activeMarker && (
        <Box position={'absolute'} top={0} left={0}>
          <RouteCard vessel={selectedVessel} open={true} />
        </Box>
      )}
    </>
  );
};

export default React.memo(MarkerContainer);
